import { Link } from "react-router-dom";
import { hotTopics, topicCategories } from "@/mocks/topics";

export default function CategorySection() {
  return (
    <section id="categories" className="mx-auto w-full max-w-[1280px] px-4 py-14 md:px-8 md:py-20">
      <div className="max-w-2xl">
        <span className="font-label text-xs font-bold tracking-[0.25em] text-primary-600">
          CATEGORIES
        </span>
        <h2 className="mt-2 font-heading text-3xl font-black text-foreground-950 md:text-4xl">
          主题分类
        </h2>
        <p className="mt-2 text-sm text-foreground-600">
          按领域整理热议话题，想只看某一类瓜，直接进对应分类翻更省事。
        </p>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {topicCategories.map((cat) => {
          const count = hotTopics.filter((t) => t.categorySlug === cat.slug).length;
          return (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex items-start gap-4 rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300 hover:bg-secondary-50"
            >
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-secondary-100 text-secondary-700 transition-colors group-hover:bg-primary-100 group-hover:text-primary-700">
                <i className={`${cat.icon} h-6 w-6 flex items-center justify-center`}></i>
              </span>
              <span className="flex flex-1 flex-col">
                <span className="flex items-center justify-between">
                  <span className="font-heading text-lg font-bold text-foreground-950">
                    {cat.name}
                  </span>
                  <span className="font-label text-xs text-foreground-500">{count} 条</span>
                </span>
                <span className="mt-1.5 text-sm leading-relaxed text-foreground-600">
                  {cat.desc}
                </span>
              </span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}